<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl=""></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/myCollect">我的收藏</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					<div class="leftMenu">
						<p @click="toMyPage('myOrder')">
							<i class="el-icon-s-unfold"></i> 我的订单
						</p>
						<p @click="toMyPage('myCourse')">
							<i class="el-icon-menu"></i> 我的课程
						</p>
						<p class="sel">
							<i class="el-icon-star-on"></i> 我的收藏
						</p>
						<p @click="toMyPage('myPartner')">
							<i class="el-icon-s-custom"></i> 我的团队
						</p>
					</div>
					<div class="rightList">
						<div class="status">
							<div v-for="(status, index) in typeList" :class="index===selIndex?'status statusSel':'status'"
								@click="onStatusChange(index)">
								<span>{{status.name}}</span>
								<span />
							</div>
						</div>
						<div class="list" v-if="collectList&&collectList.length">
							<div class="listItem" v-if="selIndex==0" v-for="one in collectList" :key="one.id"
								@click="toCourseDetail(one)">
								<div class="info">
									<div class="pro">
										<img :src="one.course.thumb_image"></img>
										<div class="right">
											<span>{{one.course.title}}</span>
											<span>{{one.course.description}}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="listItem" v-if="selIndex==1" v-for="one in collectList" :key="one.id"
								@click="toCourseDetail(one)">
								<div class="info">
									<div class="pro">
										<div class="right">
											<span>{{one.articles.title}}}</span>
											<span>{{one.articles.student}}</span>
										</div>
										<img :src="one.articles.images"></img>
									</div>
								</div>
							</div>
							<div class="listItem" v-if="selIndex==2" v-for="one in collectList" :key="one.id"
								@click="toCourseDetail(one)">
								<div class="info">
									<div class="pro">
										<img :src="one.special.image"></img>
										<div class="right">
											<span>{{one.special.name}}</span>
											<span>共{{one.special.course_ids.split(',').length}}讲</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else class="noData">
							<img src="@/assets/empty.jpg"></img>
							<span>无数据</span>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		computed: {
			Price() {
				return (price, digit) => parseFloat(price).toFixed(digit || 0);
			},
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>